// @ts-check
const Token = require('markdown-it/lib/token');
const escapeHtml = require('stringify-entities').escape;

const TAG_NAME_BINGO_TABLE = 'bingo_table';
const START_TAG = `[${TAG_NAME_BINGO_TABLE}]`;
const END_TAG = `[/${TAG_NAME_BINGO_TABLE}]`;

const CLASS_NAME_TO_BE_REPLACED_TO_VUE_COMPONENT = 'kamigame-bingo-tool-div-to-be-replaced';

/**
 * @param {import('markdown-it/lib/rules_block/state_block')} state
 * @param {number} startIndex
 * @param {number} endIndex
 */
const extractEscapedContents = (state, startIndex, endIndex) => {
  const contents = [];
  for (let index = startIndex; index <= endIndex; index++) {
    const line = state.getLines(index, index + 1, state.blkIndent, false).trim();
    if (line !== END_TAG) {
      contents.push(escapeHtml(line));
    } else {
      return { nextStartLine: index + 1, escapedContents: contents };
    }
  }

  return { nextStartLine: undefined, escapedContents: [] };
};

/** @param {import('markdown-it')} md */
module.exports = (md) => {
  md.block.ruler.before('paragraph', TAG_NAME_BINGO_TABLE, (state, startLine, endLine) => {
    const firstLine = state.getLines(startLine, startLine + 1, state.blkIndent, false).trim();
    if (!firstLine.startsWith(START_TAG)) {
      return false;
    }

    const bingoTableName = firstLine.replace(START_TAG, '').trim();

    const { nextStartLine, escapedContents } = extractEscapedContents(state, startLine + 1, endLine);
    if (escapedContents.length === 0) {
      return false;
    }

    const bingoTableToken = new Token('html_inline', '', 0);
    bingoTableToken.content = `<div class="${CLASS_NAME_TO_BE_REPLACED_TO_VUE_COMPONENT}" data-bingo-table-name="${bingoTableName}" data-bingo-table-info="${escapedContents}"></div>`;
    state.tokens.push(bingoTableToken);

    // ローカルで確認する場合は、 http://127.0.0.1:57777/share-modal.js' を使用する
    // 加えて、twitter-sharing の main.go の AllowedOrigins に http://127.0.0.1:8888 を追加して、http://127.0.0.1:8888/テスト/bingo-table.html にアクセスする

    // @ts-ignore
    state.md.helperScripts.add('https://kamigame.jp/kamigame-twitter-sharing/js/share-modal.js');
    // state.md.helperScripts.add('http://127.0.0.1:57777/share-modal.js');

    state.line = nextStartLine;
    return true;
  });
};
